export default function () {
  this.$el = $('#invite_student');
  this.$nameSearchEl = $('#student_search_first_name, #student_search_last_name');
  this.$emailSearchEl = $('#student_search_email');

  this.selectedStudent = ko.observable({
    first_name: ko.observable(),
    last_name: ko.observable(),
    email: ko.observable(),
    external_id: ko.observable(),
    role: ko.observable('Student')
  });

  this.validateBulkInvite = () => {
    if (this.selectedStudents().length) {
      return true;
    } else {
      Kadenze.UIUtil.showNotice(
        this.inviteModalEl.querySelector('.modal-footer'),
        {
          status: 'error',
          message: I18n.t('students.new.select_one')
        },
        5000
      );

      return false;
    }
  };

  this.studentSpreadsheet = ko.observableArray();
  this.selectedStudents = ko.observableArray();

  this.getModalTemplate = () => {
    const  role = Kadenze.Util.getParameterByName('role');
    const  instructions = I18n.t('students.new.instructions', {role: I18n.t('roles.'+ role.toLowerCase())})
    const template = JST['templates/bulk_student_invite']({instructions: instructions});
    return I18n.tt(template, 'en');
  };

  this.templates = {
    BulkStudentInvite: this.getModalTemplate()
  };

  this.initUI = () => {
    this.inviteModalEl = document.querySelector('.modal')

    if (this.autocompleteInvite)
      this.initTypeaheads();

    this.initBulkUploader();
  };

  this.resetSelectedStudent = () => {
    this.client_errors = ko.validation.group(
      this.selectedStudent(),
      { deep: true }
    );

    this.selectedStudent().first_name('');
    this.selectedStudent().last_name('');
    this.selectedStudent().email('');
    this.selectedStudent().external_id('');

    this.client_errors.showAllMessages(false);

    this.selectedStudents([]);

    document.getElementById('select_all').checked = false

    document.querySelectorAll('label[for=select_all]')
      .forEach(el => el.style = null)
  };

  this.initSearchEngine = type => {
    const statusIndicatorEl = document.querySelector('.status_indicator')

    const studentSearch = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace(type),
      queryTokenizer: Bloodhound.tokenizers.whitespace,

      limit: 5,

      remote: {
        url: Kadenze.Routes.students_list_path({ q: '%QUERY', type }),

        filter: students => {
          return students.map(student => {
            return {
              name: student.first_name + ' ' + student.last_name,
              first_name: student.first_name,
              last_name: student.last_name,
              email: student.email.trim(),
              role: this.selectedStudent().role(),
              external_id: student.external_id
            };
          });
        },

        ajax: {
          dataType: 'json',
          contentType: 'application/json',
          beforeSend: () => statusIndicatorEl.innerHTML = 'Searching...',
          complete: () => statusIndicatorEl.innerHTML = '',
        }
      }
    });

    studentSearch.initialize();

    return studentSearch;
  };

  this.initTypeahead = ($element, key) => {
    const searchEngine = this.initSearchEngine(key);

    $element.typeahead({
      hint: false,
      highlight: true,
      minLength: 1
    },
    {
      name: 'students',
      displayKey: key,
      source: searchEngine.ttAdapter()
    });

    $element.on('typeahead:selected', this.resultsSelected);
  };

  this.resultsSelected = (obj, { first_name, last_name, email, role, external_id }) => {
    this.selectedStudent().first_name(first_name);
    this.selectedStudent().last_name(last_name);
    this.selectedStudent().email(email);
    this.selectedStudent().role(role);
    this.selectedStudent().external_id(external_id);
  };

  this.initTypeaheads = () => {
    this.initTypeahead(this.$nameSearchEl, 'name');
    this.initTypeahead(this.$emailSearchEl, 'email');
  };

  this.initBulkUploader = () => {
    const self = this;

    new Dropzone('#bulk_upload_lnk', {
      url: Kadenze.Routes.temp_spreadsheet_upload_path(),

      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },

      maxFiles: 1,
      autoProcessQueue: true,
      acceptedFiles: '.csv,.xls,.xlsx',
      paramName: 'file',
      previewTemplate: '<span></span>',

      init: function() {
        this.on('sending', (file, xhr, formData) => {
          Kadenze.UIUtil.showLoadingIndicator(self.$el);
        });

        this.on('success', (file, response) => {
          if (response.data.length) {
            self.bindStudentSpreadsheet(response.data);
            $(self.inviteModalEl).modal('show');
          } else {
            Kadenze.UIUtil.showNotice(
              self.$el,
              {
                status: 'error',
                message: I18n.t('students.new.spreadsheet_empty')
              },
              5000
            );
          }
        });

        this.on('error', (file, errorMessage) => {
          Kadenze.UIUtil.showNotice(
            self.$el,
            {
              status: 'error',
              message: I18n.t('students.new.spreadsheet_invalid')
            },
            5000
          );
        });

        this.on('complete', file => {
          Kadenze.UIUtil.hideLoadingIndicator(self.$el);
          this.removeAllFiles();
        });
      }
    })
  };

  this.bindStudentSpreadsheet = students => {
    const mapping = {
      create: options => {
        const vm = ko.mapping.fromJS(options.data);

        vm.role = ko.observable(this.selectedStudent().role());

        if (!options.data.external_id)
          vm.external_id = ko.observable(this.selectedStudent().external_id());

        return vm;
      }
    };

    this.studentSpreadsheet(ko.mapping.fromJS(students, mapping)());
  };

  this.selectAllStudents = (item, event) => {
    const selectAll = event.target.checked
    const labels = this.inviteModalEl.querySelectorAll('table > tbody label')

    if (selectAll) {
      this.selectedStudents(this.studentSpreadsheet());
      labels.forEach(lbl => lbl.style.backgroundPosition = '0px -32px')
    } else {
      this.selectedStudents([])
      labels.forEach(lbl => lbl.style = {})
    }

    return true;
  };

  this.inviteStudent = (item, event) => {
    this.confirmUnpublishedStudentInvites(this.invite)
  };

  this.invite = () => {
    this.client_errors = ko.validation.group(
      this.selectedStudent(),
      { deep: true }
    );

    if (this.client_errors().length) {
      this.client_errors.showAllMessages();
    } else {
      this.sendInvitation();
    }
  };

  this.inviteStudents = (item, event) => {
    if (this.validateBulkInvite()) {
      this.confirmUnpublishedStudentInvites(() => {
        this.sendInvitation({ bulk: true });
        $(this.inviteModalEl).modal('hide');
      })
    }
  };

  this.confirmUnpublishedStudentInvites = fn => {
    if (this.isInvitingStudentToUnpublished()) {
      Kadenze.UIUtil.confirmAction(I18n.t('dict.draft_course_invite_confirm_message'), fn)
    } else {
      fn()
    }
  }

  this.isInvitingStudentToUnpublished = () => {
    return this.courseStatus != 'published' &&
      this.selectedStudent().role() == 'Student'
  }

  this.sendInvitation = (options = {}) => {
    const data = {}

    if (options.bulk) {
      data.students = ko.mapping.toJS(
        this.selectedStudents(),
        { include: ['role', 'external_id'] }
      )
    } else {
      data.students = [ko.mapping.toJS(this.selectedStudent())]
    }

    Kadenze.Ajax.post({
      routeName: 'course_invite_student',
      routeParams:this.courseId,
      data,
      loadingContainer: this.$el,
      done: ({ message }) => {
        this.resetSelectedStudent();
      },
      fail: ({ responseJSON: { message } }) => {
        new Kadenze.Notice.error({ message });
      },
    });
  };

  (() => {
    this.courseId = document.getElementById('course_id').value
    this.courseStatus = document.getElementById('course_status').value
    this.autocompleteInvite = document.getElementById('autocomplete_invite').value

    const role = Kadenze.Util.getParameterByName('role');

    if (role)
      this.selectedStudent().role(role);
  })();
}
